import moment from "moment";
import { SlotsOption } from "../../requestTurn/requestedTurn.type";
import { Hour } from "../types";

export const isSameDate = (date: Date | undefined, stringDMYDate: string) =>
  date &&
  date.toLocaleDateString() ===
    moment(stringDMYDate, "DD/MM/YYYY").toDate().toLocaleDateString();

export const getTimesBySlotsOptions = (
  availableTurns: SlotsOption[],
  date: Date,
) => {
  const times: Hour[] = [];

  availableTurns.forEach((x, i) => {
    const sameDate = isSameDate(date, x.date);

    if (sameDate && !times.find((already) => already.value === x.time)) {
      times.push({ name: `${x.time}`, value: x.time, id: `${i}-${x.time}` });
    }
  });

  return times;
};

export const getTimesBySlotsEdit = (
  availableTurns: SlotsOption[],
  date: Date,
) => {
  const times: { name: string; value: string; }[] = [];

  availableTurns.forEach((x, i) => {
    const sameDate = isSameDate(date, x.date);

    if (sameDate && !times.find((already) => already.value === x.time)) {
      times.push({ name: `${x.time}`, value: x.time });
    }
  });

  return times;
};